import { render, staticRenderFns } from "./MarkdownDialog.vue?vue&type=template&id=05e167c0&scoped=true"
import script from "./MarkdownDialog.vue?vue&type=script&lang=js"
export * from "./MarkdownDialog.vue?vue&type=script&lang=js"
import style0 from "./MarkdownDialog.vue?vue&type=style&index=0&id=05e167c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e167c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VSpacer})
